/** Shared stage / pipeline utilities. */

export function daysBetween(isoA, b = new Date()) {
  if (!isoA) return 0;
  const a = new Date(isoA);
  return (b.getTime() - a.getTime()) / 86400000;
}

export function daysInStageLabel(card) {
  const d = Math.floor(daysBetween(card.stage_entered_at));
  return `${d}d`;
}

export function isOverdueInStage(card, template) {
  if (!template) return false;
  if (card.current_stage >= 16) return false;
  return daysBetween(card.stage_entered_at) > template.day_target;
}

export function daysOverdue(card, template) {
  if (!template) return 0;
  if (card.current_stage >= 16) return 0;
  return daysBetween(card.stage_entered_at) - template.day_target;
}

export function isNextActionDue(card) {
  if (!card.next_action_date) return false;
  const today = new Date().toISOString().slice(0, 10);
  return card.next_action_date <= today;
}

export function isSnoozed(card) {
  return !!(card.snoozed_until && card.snoozed_until > new Date().toISOString().slice(0, 10));
}

export function progressOf(card) {
  const total = card.tasks_state?.length || 0;
  const done = card.tasks_state?.filter((t) => t.done).length || 0;
  return { done, total, pct: total ? (done / total) * 100 : 0 };
}

export function isAtRisk(card, template) {
  if (!template) return false;
  if (card.current_stage >= 16) return false;
  const d = daysBetween(card.stage_entered_at);
  return d <= template.day_target && d >= template.day_target - 2 && d > 0;
}

export function userInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function deriveInitials(fullName) {
  if (!fullName) return "?";
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// Lead prioritization score — higher = more urgent to work. Snoozed leads score 0.
export function priorityScore(card, template) {
  const today = new Date().toISOString().slice(0, 10);
  if (card.snoozed_until && card.snoozed_until > today) return 0;
  if (card.current_stage === 16 || card.current_stage === 109) return 0; // finished leads aren't "urgent"
  let s = 0;
  const target = (template && template.day_target) || 0;
  const daysIn = daysBetween(card.stage_entered_at);
  if (target && daysIn > target) s += Math.min(60, Math.round((daysIn - target) * 3));
  if (card.last_contacted_at) {
    s += Math.min(20, Math.round(daysBetween(card.last_contacted_at)));
  } else {
    s += 10;
  }
  s += (card.contact_attempts || 0) * 5;
  if (!card.next_action_date) s += 15;
  else if (card.next_action_date <= today) s += 10;
  if (card.blocked) s += 8;
  return Math.round(s);
}

export function priorityLabel(score) {
  if (score >= 45) return { key: "high", label: "High", color: "#b91c1c" };
  if (score >= 20) return { key: "med", label: "Med", color: "#b45309" };
  return { key: "low", label: "Low", color: "#64748b" };
}
